"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterSummary = void 0;
var react_1 = __importStar(require("react"));
var registers_1 = require("../../utils/registers");
var IconSummary_1 = require("../IconSummary");
var utils_1 = require("./utils");
exports.RegisterSummary = (0, react_1.forwardRef)(function (_a, ref) {
    var timingCategory = _a.timingCategory, context = _a.context, labelOverride = _a.label, testId = _a["data-testid"], rest = __rest(_a, ["timingCategory", "context", "label", 'data-testid']);
    var friendlyLabel = timingCategory
        ? (0, utils_1.getFriendlyLabel)(timingCategory)
        : null;
    var label = labelOverride ? (labelOverride) : friendlyLabel ? (react_1.default.createElement(registers_1.RegisterLabel, { friendlyLabel: friendlyLabel, capitalise: true })) : undefined;
    return (react_1.default.createElement(IconSummary_1.IconSummary, __assign({ label: label, icon: timingCategory ? (0, utils_1.getRegisterIcon)(timingCategory) : 'meter', value: context, "data-testid": testId ||
            "register-summary".concat(timingCategory ? "-".concat(timingCategory) : '') }, rest, { ref: ref })));
});
